import isEqual from 'lodash/isEqual'
export default {
  namespaced: true,
  state: {
    codes: []
  },
  mutations: {
    itemNotExist(state, payload) {
      let index = state.codes.findIndex(x => x.form == payload.form && x.code == payload.code && isEqual(x.additionalBroadcastFields, payload.additionalBroadcastFields))
      if (index === -1) {
        state.codes.push(payload)
      }
    },
    itemExist(state, payload) {
      let index = state.codes.findIndex(x => x.form == payload.form && x.code == payload.code && isEqual(x.additionalBroadcastFields, payload.additionalBroadcastFields))
      if (index > -1) {
        state.codes.splice(index, 1)
      }
    },
  },
  actions: {
    clearFormCodes({ dispatch, commit, state, }) {
      state.codes = []
    },
    clearFormCodeByKey(state, key) {
      state.codes, findIndex(x => isEqual(x, key))
    }
  },
  getters: {
    isCodeInNotFoundArray: state => (form, code, additionalBroadcastFields) => {

      if (typeof code !== 'string')
        code = String(code)
      return state.codes.findIndex(x => x.form == form && x.code == code && isEqual(x.additionalBroadcastFields, additionalBroadcastFields)) > -1
    },
  },
}